import { useState } from "react";
import { apiURL } from "../../../consts/URLs";
import { RESET_PASSWORD } from "../../endpointList";
import { fetchRequest, getOptions } from "../../utils";

const useResetPassword = () => {
  const [resetPasswordResponse, setResetPasswordResponse] = useState<any>();
  const [resetPasswordResult, setResetPasswordResult] = useState<any>();

  const resetPassword = (obj: any) => {
    const url = `${apiURL}/${RESET_PASSWORD}`;
    const options = getOptions({ method: "POST", body: obj  }); 
    fetchRequest(
      url,
      options,
      setResetPasswordResponse,
      setResetPasswordResult
    );
  };

  return { resetPasswordResponse, resetPasswordResult, resetPassword };
};
export default useResetPassword;
